export default __webpack_public_path__ + "static/media/Group -106.4a591d4f.png";